import axios from 'axios';
import { logout } from 'store/login-actions';
import envConfig from '../env-config.json';

export const BASE_URL = envConfig.REACT_APP_BASE_URL;
export const DEVICE_CONNECTION_URL = envConfig.REACT_APP_BASE_DEVICE_CONNECTION;

function createInstance({
  baseURL,
  withAuth = true,
  withLogout = true,
  responseTransform = (res) => ({ ...res.data }),
}) {
  const instance = axios.create({ baseURL });

  if (withAuth) {
    instance.interceptors.request.use(async (config) => {
      const authToken = localStorage.getItem('token');
      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }
      return config;
    });
  }

  instance.interceptors.response.use(
    (response) => responseTransform(response),
    (error) => {
      // A network-level failure arrives with no `error.response` at all: connection
      // reset, timeout, device offline, or an error response the browser blocked for
      // missing CORS headers. Destructuring it directly threw a TypeError from inside
      // this handler, which discarded the real error and rejected the promise every
      // caller expects to resolve — leaving loading states stuck with nothing to show.
      // statusCode 0 means "no HTTP response", so callers can tell it apart from a
      // server-sent status without tripping over a non-numeric value.
      const { data = {}, status = 0 } = error.response || {};
      const { errors = [] } = data;
      if (
        withLogout &&
        status === 401 &&
        ((errors.length === 1 && errors[0] === 'Unauthorized') || errors.length === 0)
      ) {
        localStorage.setItem('error', JSON.stringify('unauthorized'));
        logout();
      }
      return { statusCode: status, msg: errors.join('\n') };
    },
  );

  return instance;
}

export default createInstance;
